import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { CTAButton } from '../ui/CTAButton';
export function BeforeAfterSection() {
  return <section className="w-full py-20 md:py-32 px-4 md:px-5" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        {/* Headline */}
        <ScrollReveal data-id="element-57">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight text-center mb-3" data-id="element-58">
            Antes vs Después:{' '}
            <span className="text-accent" data-id="element-59">
              la diferencia es el primer segundo
            </span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.08} data-id="element-60">
          <p className="text-lg md:text-xl text-neutral-400 text-center mb-12 md:mb-16" data-id="element-61">
            El contenido no cambia. Solo el inicio.
          </p>
        </ScrollReveal>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-62">
          {/* ANTES */}
          <ScrollReveal delay={0.1} data-id="element-63">
            <div className="bg-surface border border-red-500/20 rounded-2xl p-6 md:p-8 h-full" data-id="element-64">
              {/* Label */}
              <div className="flex items-center gap-2 mb-6" data-id="element-65">
                <span className="text-sm" data-id="element-66">❌</span>
                <span className="text-xs font-bold text-red-400 uppercase tracking-widest" data-id="element-67">
                  Antes
                </span>
              </div>

              {/* Example hook */}
              <div className="bg-red-500/5 border border-red-500/10 rounded-xl p-4 md:p-5 mb-6" data-id="element-68">
                <p className="text-neutral-400 italic leading-relaxed" data-id="element-69">
                  "Hola, ¿cómo están? Hoy les quiero contar algo…"
                </p>
              </div>

              {/* Results */}
              <div className="space-y-2.5" data-id="element-70">
                <div className="flex items-center gap-2" data-id="element-71">
                  <div className="w-1.5 h-1.5 rounded-full bg-red-500/40" data-id="element-72" />
                  <span className="text-sm text-neutral-500" data-id="element-73">
                    Scroll inmediato
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-74">
                  <div className="w-1.5 h-1.5 rounded-full bg-red-500/40" data-id="element-75" />
                  <span className="text-sm text-neutral-500" data-id="element-76">
                    Nadie se queda
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-77">
                  <div className="w-1.5 h-1.5 rounded-full bg-red-500/40" data-id="element-78" />
                  <span className="text-sm text-neutral-500" data-id="element-79">
                    Algoritmo no lo empuja
                  </span>
                </div>
              </div>
            </div>
          </ScrollReveal>

          {/* DESPUÉS */}
          <ScrollReveal delay={0.18} data-id="element-80">
            <div className="relative bg-surface border border-accent/25 rounded-2xl p-6 md:p-8 h-full overflow-hidden group" data-id="element-81">
              {/* Glow effect */}
              <div className="absolute inset-0 pointer-events-none opacity-60 group-hover:opacity-100 transition-opacity duration-500" style={{
              background: 'radial-gradient(ellipse at top right, rgba(255,107,0,0.08) 0%, transparent 60%)'
            }} data-id="element-82" />

              <div className="relative" data-id="element-83">
                {/* Label */}
                <div className="flex items-center gap-2 mb-6" data-id="element-84">
                  <span className="text-sm" data-id="element-85">⚡</span>
                  <span className="text-xs font-bold text-accent uppercase tracking-widest" data-id="element-86">
                    Después
                  </span>
                </div>

                {/* Example hook */}
                <div className="bg-accent/5 border border-accent/15 rounded-xl p-4 md:p-5 mb-6" data-id="element-87">
                  <p className="text-neutral-200 italic leading-relaxed font-medium" data-id="element-88">
                    "El 90% de los creadores cometen este error en su primer
                    segundo — y por eso nadie los ve."
                  </p>
                </div>

                {/* Results */}
                <div className="space-y-2.5" data-id="element-89">
                  <div className="flex items-center gap-2" data-id="element-90">
                    <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-91" />
                    <span className="text-sm text-neutral-300" data-id="element-92">
                      Más retención
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-93">
                    <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-94" />
                    <span className="text-sm text-neutral-300" data-id="element-95">Más vistas</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-96">
                    <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-97" />
                    <span className="text-sm text-neutral-300" data-id="element-98">
                      Más seguidores
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-99">
                    <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-100" />
                    <span className="text-sm text-neutral-300" data-id="element-101">Más ventas</span>
                  </div>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>

        {/* Transition text + CTA */}
        <ScrollReveal delay={0.25} data-id="element-102">
          <div className="mt-14 md:mt-20 text-center" data-id="element-103">
            <p className="text-lg md:text-xl text-white font-bold mb-2" data-id="element-104">
              Esto es exactamente lo que obtienes con{' '}
              <span className="text-accent" data-id="element-105">Hook Arsenal.</span>
            </p>
            <p className="text-base md:text-lg text-neutral-400 mb-8 max-w-lg mx-auto" data-id="element-106">
              200 ganchos listos para usar, probados en creadores reales.
            </p>
            <CTAButton href="#pricing" data-id="element-107">Quiero Hook Arsenal</CTAButton>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}